var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main z-10 mt-16 md:mt-20 lg:mt-0"},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }